import * as React from 'react';

const FederatedLoginFacebookIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.49 24.0018C19.1174 24.0018 24.49 18.6293 24.49 12.0019C24.49 5.37451 19.1174 0.00195312 12.49 0.00195312C5.86257 0.00195312 0.48999 5.37451 0.48999 12.0019C0.48999 18.6293 5.86257 24.0018 12.49 24.0018Z"
      fill="#1977F3"
    />
    <path
      d="M17.1582 15.4712L17.6897 12.0017H14.3619V9.75054C14.3619 8.80215 14.826 7.87571 16.3178 7.87571H17.8315V4.92255C17.8315 4.92255 16.4579 4.68799 15.145 4.68799C12.4044 4.68799 10.6123 6.3485 10.6123 9.35734V12.0017H7.56459V15.4712H10.6123V23.8565C11.2231 23.9527 11.8492 24.0016 12.4871 24.0016C13.125 24.0016 13.7511 23.951 14.3619 23.8565V15.4712H17.1582Z"
      fill="white"
    />
  </svg>
);

export default FederatedLoginFacebookIcon;
